export default "__VITE_ASSET__wv9ZwJwb__"